class LWHamburger extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.isOpen = false;
    }

connectedCallback() {
    this.render();
    
    // De 'target' logica voor de hamburger
    if (this.hasAttribute('target')) {
        this.targetMenu = document.getElementById(this.getAttribute('target'));
    }

    // DE FIX: Check of verplaatsen écht nodig is
    // We checken of de parent NIET de body is
    if (this.parentElement && this.parentElement !== document.body) {
        document.body.appendChild(this);
    }
}

    toggleMenu() {
        this.isOpen = !this.isOpen;
        this.shadowRoot.querySelector('.hamburger').classList.toggle('open');
        if (this.targetMenu) {
            this.isOpen ? this.targetMenu.setAttribute('open', '') : this.targetMenu.removeAttribute('open');
        }
    }

    render() {
        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                position: fixed !important;
                top: 40px;
                right: 40px;
                z-index: 99; /* Belachelijk hoog, altijd bovenop */
                display: block !important;
                cursor: pointer;
            }

            .hamburger {
                width: 40px;
                height: 25px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }

            .line {
                width: 100%;
                height: 4px;
                background-color: #ffffff; /* Wit */
                transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            }

            .open .line:nth-child(1) { transform: translateY(10.5px) rotate(45deg); }
            .open .line:nth-child(2) { opacity: 0; }
            .open .line:nth-child(3) { transform: translateY(-10.5px) rotate(-45deg); }

            @media (max-width: 767px) {
                :host { top: 20px; right: 20px; }
            }

            @media (min-width: 600px) {
                .hamburger {
                    display: none;
                }
            }
        </style>
        <div class="hamburger" onclick="this.parentNode.host.toggleMenu()">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
        </div>
        `;
    }
}

customElements.define('lw-hamburger', LWHamburger);